import { Flex } from '../../2022-component-library';
import { useCalibration } from '../../context/calibrationContext';

export const StimulusPointVF2 = ({ coords, color }) => {
  const {
    calibrationData: { circleDimensionsPx },
  } = useCalibration();
  return (
    <Flex
      backgroundColor={color}
      height={`${circleDimensionsPx}px`}
      width={`${circleDimensionsPx}px`}
      borderRadius='50%'
      style={{ position: 'absolute', top: `${coords?.y || 0}px`, left: `${coords?.x || 0}px` }}
    ></Flex>
  );
};
